import { ComponentType, Overlay as O, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, Injector, inject } from '@angular/core';

import { OverlayConfig, OverlayData, OverlayRef, OVERLAY_DATA } from './index';

@Injectable({
  providedIn: 'root',
})
export class Overlay {
  private o = inject(O);


  get scrollStrategies(): ScrollStrategyOptions {
    return this.o.scrollStrategies;
  }

  attach<Type>(component: ComponentType<Type>, config: OverlayConfig = {}): OverlayRef<Type> {
    return this.create<Type>(component, config).attach();
  }

  create<Type>(
    component: ComponentType<Type> | TemplatePortal<Type>,
    config: OverlayConfig = {}
  ): OverlayRef<Type> {
    const ref = this._createReference<Type>(component, config);
    const injector = this._createInjector<Type>(ref, config?.data);

    return ref.init(injector, config);
  }

  private _createReference<Type>(
    component: ComponentType<Type> | TemplatePortal<Type>,
    { position, scrollStrategy, hasBackdrop, panelClass, backdropClass, clickableBackdrop }: Partial<OverlayConfig>
  ): OverlayRef<Type> {
    const backdrop = typeof backdropClass === 'string' ? backdropClass : 'overlay--backdrop';
    const overlayRef = this.o.create({
      backdropClass: backdrop,
      positionStrategy: position,
      scrollStrategy,
      hasBackdrop,
      panelClass,
    });

    const ref = new OverlayRef(overlayRef, component);

    if (hasBackdrop && clickableBackdrop) {

      // HACK setTimeout required to propagate mouse click to autocomplete overlay,
      // otherwise overlay will remain in DOM
      overlayRef.backdropClick().subscribe(() => setTimeout(() => ref.close(), 0));
    }

    return ref;
  }

  private _createInjector<Type>(ref: OverlayRef<Type>, data: OverlayData): Injector {
    return Injector.create({
      providers: [
        { provide: OVERLAY_DATA, useValue: data },
        { provide: OverlayRef, useValue: ref },
      ],
    });
  }
}
